import React from 'react';

const IconPencil = () => {
	return (
		<svg aria-hidden="true" className='tw-block' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1.50218 10.6004H2.37653L8.39965 4.5773L7.5253 3.70293L1.50218 9.72605V10.6004ZM10.6547 3.85423L8.25476 1.44145L9.00733 0.688901C9.22528 0.470956 9.47997 0.361984 9.77141 0.361984C10.0629 0.361984 10.3176 0.470956 10.5355 0.688901L11.4137 1.56708C11.6205 1.77392 11.7218 2.03075 11.7175 2.33758C11.7133 2.64442 11.6077 2.90125 11.4009 3.10808L10.6547 3.85423ZM9.915 4.58755L2.8355 11.6671H0.435547V9.26708L7.51503 2.18758L9.915 4.58755Z" fill="#545454"/>
		</svg>
	);
};

export default IconPencil;
